import { api } from './client';

export interface Variant {
  text: string;
  rationale: string;
}

export interface GeneratedPin {
  titles: Variant[];
  descriptions: Variant[];
  suggestedHashtags: string[];
  keywordsUsed: string[];
  notes: string;
}

export interface GeneratePinInput {
  seed: string;
  region?: string;
  url?: string;
  tone?: string;
}

export function generatePin(input: GeneratePinInput, token: string | null): Promise<GeneratedPin> {
  return api.post<GeneratedPin>('/pin-generator/generate', input, token);
}
